import { render, staticRenderFns } from "./detalle.vue?vue&type=template&id=6c569d5e&scoped=true&"
import script from "./detalle.vue?vue&type=script&lang=js&"
export * from "./detalle.vue?vue&type=script&lang=js&"
import style0 from "./detalle.vue?vue&type=style&index=0&id=6c569d5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c569d5e",
  null
  
)

export default component.exports